// ‹ 12 of 107 › — pairs with useRecordNav. Renders nothing until the id list
// is known so the header doesn't jump when it arrives.
export default function RecordNav({ idx, total, hasPrev, hasNext, goPrev, goNext, label = 'record' }) {
  if (total === 0 || idx === -1) return null;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      <button className="btn btn-outline btn-sm" onClick={goPrev} disabled={!hasPrev} style={{ padding: '4px 10px', opacity: hasPrev ? 1 : 0.35 }} title={`Previous ${label}`} aria-label={`Previous ${label}`}>‹</button>
      <span style={{ fontSize: 11, color: 'var(--text3)', whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>{idx + 1} of {total}</span>
      <button className="btn btn-outline btn-sm" onClick={goNext} disabled={!hasNext} style={{ padding: '4px 10px', opacity: hasNext ? 1 : 0.35 }} title={`Next ${label}`} aria-label={`Next ${label}`}>›</button>
    </div>
  );
}
